import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { RacingConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixturePreview } from '@frontend/sports/racing/feature/models';
import { map, switchMap } from 'rxjs';

import { BestOddsGuaranteedService } from './services/best-odds-guaranteed.service';

@Component({
    selector: 'ms-best-odds-counter',
    templateUrl: 'best-odds-counter.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BestOddsCounterComponent {
    fixtures = input.required<WinGameFixturePreview[]>();
    fixtures$ = toObservable(this.fixtures);

    text = toSignal(
        this.fixtures$.pipe(
            switchMap((fixtures) =>
                this.bestOddsService.getEligibleFixturesCount(fixtures).pipe(
                    map((count) => {
                        if (this.racingConfig.isBOGEnabled && count > 0) {
                            return this.sitecore.horseRacing.common.bogCounterText.replace('{count}', count.toString());
                        }

                        return undefined;
                    }),
                ),
            ),
        ),
        { requireSync: false },
    );

    constructor(
        private sitecore: Sitecore,
        private bestOddsService: BestOddsGuaranteedService,
        private racingConfig: RacingConfig,
    ) {}
}
